import baseFetcher from './baseFetcher';

// The Apply fetcher swallows all errors
// If something breaks, just fail over to a base case
//
// Some examples:
// If calls for session or prequal status error, treat the user like a brand-new consumer
// If the `prefill` call errors, render any forms without a prefill
//
// None of the above cases are serious enough to warrant blocking our top of funnel.
const noErrorFetcher = async (...args) => {
  try {
    return await baseFetcher(...args);
  } catch {
    return null;
  }
};

export default noErrorFetcher;
